module.exports = __webpack_public_path__ + "static/media/filter-black.8500442d.svg";